// extracted by mini-css-extract-plugin
export default {"tooltip":"Notifications_tooltip__gBKRn"};